import React from "react";
// import { Button } from "@mui/material";
import { Button } from "react-bootstrap";
import sls from "../assets/logo/sls.png";
import { useNavigate } from "react-router-dom";
import colors from "../utils/colors";

import "./style.css";

export default function Navbar() {
  const navigate = useNavigate();
  return (
    <div className="nav">
      <div className="nav-body">
        <img
          src={sls}
          alt="sls logo"
          height="70px"
          style={{ margin: "auto 0" }}
        />
        <div
          style={{
            width: "250px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
            // background: "lightyellow",
          }}
        >
          <div>
            {/* <Button variant="light" size="sm">
              Responder:
            </Button> */}
          </div>

          <div>
            <Button
              variant="info"
              size="lg"
              className="nav-upload-btn"
              style={{
                background: colors.SLSprimary,
                color: "white",
                border: "none",
              }}
              onClick={() => {
                navigate("/sls/upload");
              }}
            >
              Upload Video
            </Button>
          </div>
          <div
            onClick={() => {
              navigate("/");
            }}
          >
            <Button variant="outlined" size="sm">
              LogOut
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
